/* eslint-disable react-hooks/exhaustive-deps */
import { Device } from "@twilio/voice-sdk";
import { VonageClient } from "@vonage/client-sdk";
import { Image } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { BiSolidMessage } from "react-icons/bi";
import { BsFillQuestionDiamondFill } from "react-icons/bs";
import { FaPhone } from "react-icons/fa";
import { IoIosLock } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import allActions from "../../Store/action";
import { CALL_ACTION_TYPE } from "../../Store/call/Type";
import {
  BASEURL,
  twilioPhoneNumberFormatter,
  timezoneFormatter,
  convertTime,
} from "../../utilites";
import useIsMobile from "../Custom/useIsMobile";
import useWindowWidth from "../Custom/useWindowWidth";
import Modal from "../Dashboard/Modal";
import UserAvatar from "../UserAvatar";
import AudioCallModal from "../forms/Modal/AudioChatCallModal";
import VonageAudioCallModal from "../forms/Modal/VonageAudioChatCallModal";
import RequestJobDocumentForm from "../forms/RequestJobDocumentForm";
import { PiUserListLight } from "react-icons/pi";
import AiVoiceSupport from "./AiVoiceSupport";



const UserTopBar = ({
  selectedReceiver,
  getMyStatus,
  setMessage,
  handleSubmit,
  setMessageContent,
  editable = true,
  group,
  chatUsers,
  chatDisable,
  setShowUserList,
  showButtons = true,
  isAiBotMode = false,
  isAITyping = false,
  toggleAiBotMode = () => {},
  modal = false,
}) => {
  const isMobile = useIsMobile();
  const windowWidth = useWindowWidth();
  const [lastLead, setLastLead] = useState();
  const [selectedData, setSelectedData] = useState({});
  const [callData, setCallData] = useState({ status: "" });
  const [callMeta, setCallMeta] = useState("");
  const [audioConnection, setAudioConnection] = useState(null);
  const [callerUid, setcallerUid] = useState("");
  const [modalMessage, setmodalMessage] = useState({ show: false });
  const [swalProps, setSwalProps] = useState({});
  const [, setClockTick] = useState(0);

  // Refresh every minute so the receiver's local time stays current
  useEffect(() => {
    if (!selectedReceiver?.settings?.timezone) return;
    const interval = setInterval(() => setClockTick((t) => t + 1), 60000);
    return () => clearInterval(interval);
  }, [selectedReceiver?.settings?.timezone]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [
    { user },
    { chatStatus },
    { videoCallRoom, getZoomMeeting, audioCallToken },
    { LoginData },
  ] = useSelector((state) => [state, state.firebase, state.call, state.user]);
  const showError = (message) => {
    setMessage({
      show: true,
      type: "Error",
      text: message,
    });
  };
  const toggleModal = () =>
    document.querySelector(".AudioCallModalButton")?.click();
  const toggleModalVonage = () =>
    document.querySelector(".VonageAudioCallModalButton")?.click();
  const client = new VonageClient();
  useEffect(() => {
    client.on("callInvite", (callId, from, channelType) => {
      // Answer / Reject Call
    });
    client.on("callHangup", (callId, callQuality, reason) => {
      toggleModalVonage();
      setCallData({ status: "" });
    });
    client.on("legStatusUpdate", (callId, legId, status) => {
      if (status === "ANSWERED") {
        setCallData({ status: "Connected" });
      } else if (status === "RINGING") {
        setCallData({ status: "Ringing..." });
      }
    });
  }, [client]);

  useEffect(() => {
    // if Error While Creating Video Call Room
    if (!getZoomMeeting.status) {
      // Reset Message and Loading
      resetMessage();

      setMessage({
        show: true,
        type: "Error",
        text: getZoomMeeting.message,
      });
    }
    if (getZoomMeeting.status === true) {
      resetMessage();
      // Encode Room ID String
      var encodedString = window.btoa(
        JSON.stringify({
          roomId: videoCallRoom?.data?.meetingID,
          creatorUserserId: LoginData?.id,
          startUrl: getZoomMeeting.data.start_url,
          joinUrl: getZoomMeeting.data.join_url,
        }),
      );
      if(!LoginData?.isCustomer){
      handleSubmit({ type: "meeting/instant", encodedString });
      }
    }
  }, [getZoomMeeting?.status, getZoomMeeting?.message]);

  useEffect(() => {
    // if Idle
    if (videoCallRoom.status === "idle") resetMessage();

    // if Error While Creating Video Call Room
    if (!videoCallRoom.status) {
      // Reset Message and Loading
      resetMessage();

      setMessage({
        show: true,
        type: "Error",
        text: videoCallRoom.message,
      });
    }

    // if Success After Creating Video Call
    if (videoCallRoom.status === true) {
      // Get Meeting Status
      if (videoCallRoom?.data?.meetingID) {
        dispatch(
          allActions.call.getZoomMeetingIdle()
        );
        dispatch(
          allActions.call.getZoomMeeting(videoCallRoom?.data?.meetingID),
        );
      }
    }
  }, [
    videoCallRoom.status,
    videoCallRoom.message,
    videoCallRoom?.data?.meetingID,
    setMessage,
  ]);

  const proceedCall = async (token) => {
    try {
      const device = new Device(token, {
        enableImprovedSignalingErrorPrecision: true,
      });
      setCallMeta(device);
      device.on("registered", function () {
        console.log("Twilio.Device Ready to make and receive calls!");
      });
      device.on("error", function (error) {
        resetMessage();
        showError(error.toString());
      });
      const call = await device.connect({
        params: {
          To: `${twilioPhoneNumberFormatter(selectedReceiver?.phone)}`,
        },
      });
      setAudioConnection(call);
      call.on("error", (callError) => {
        resetMessage();
        toggleModal();
        showError("Something went wrong due to network connectivity!");
      });
      call.on("accept", () => {
        resetMessage();
        toggleModal();
        setCallData({ status: "Ringing....", user: selectedReceiver });
        if (call?.parameters?.CallSid) {
          console.log("heloo", call?.parameters?.CallSid);
          dispatch(
            allActions.recordings.saveRecording(call?.parameters?.CallSid),
          );
        }
      });
      call.on("disconnect", () => {});
      call.on("cancel", () => {});
    } catch (error) {}
  };
  useEffect(() => {
    // if Error While Creating Video Call Room
    if (!audioCallToken?.status && audioCallToken) {
      // Reset Message and Loading
      resetMessage();
      setMessage({
        show: true,
        type: "Error",
        text: audioCallToken?.message ? audioCallToken?.message : {},
      });
    }
    if (audioCallToken?.status === true && audioCallToken) {
      console.log("@audioCallToken", audioCallToken);
      proceedCall(audioCallToken?.data?.token);
    }
  }, [audioCallToken?.status, audioCallToken?.message]);

  // Function To Generate Meeting Link
  const CreateMeetingLink = () => {
    // if Customer, do not create meeting link
    if (user.LoginData.isCustomer) return;
    // Just to Pass Validation
    setMessageContent("Meeting Link");

    // Change Loading Status
    changeLoading(true);

    // reset Meeting Link
    dispatch(
      allActions.call.dispatchToStore({
        type: CALL_ACTION_TYPE.videoCallRoomIdle,
      }),
    );

    // Generate New Room
    const meetingData = {
      duration: CALL_ACTION_TYPE.videoCallTiming.duration,
      email: LoginData?.email,
      taxProEmail:
        LoginData?.lead?.[0]?.userpro?.user?.email || LoginData?.email,
    };
    dispatch(
      allActions.call.dispatchToStore({
        type: CALL_ACTION_TYPE.videoCallRoomIdle,
      }),
    );
    dispatch(allActions.call.createRoom(meetingData));
  };

  // Function To Reset Message
  const reset_Message = () => {
    setMessage({ show: false });
  };

  const changeLoading = (status) => {
    dispatch(allActions.global.Loader(status));
  };

  const resetMessage = () => {
    reset_Message();
    changeLoading(false);
  };
  useEffect(() => {
    loadLastLead();
  }, [selectedReceiver]);

  const loadLastLead = () => {
    if (
      selectedReceiver &&
      selectedReceiver?.role?.toLowerCase() === "customer"
    ) {
      // Get latest lead of selected receiver
      axios
        .get(`${BASEURL}/api/leads/by-customer`, {
          params: {
            id: selectedReceiver?.id,
            type: "jobs"
          },
        })
        .then((res) => {
          setLastLead(res.data.data)
        });
    } else if (lastLead) {
      setLastLead(null);
    }
  };
  const vonageCalling = async () => {
    changeLoading(true);
    axios
      .post(`${BASEURL}/api/vonage/requset-call`)
      .then((response) => {
        client
          .createSession(response.data?.data)
          .then((sessionId) => {
            setCallData({ status: "Connecting..." });
            client
              .serverCall({
                to: JSON.stringify(
                  Number(twilioPhoneNumberFormatter(selectedReceiver?.phone)),
                ),
                custom_data: JSON.stringify({ user_id: selectedReceiver?.id }),
              })
              .then((callId) => {
                changeLoading(false);
                toggleModalVonage();
                setcallerUid(callId);
              })
              .catch((error) => {
                changeLoading(false);
              });
          })
          .catch((error) => {
            changeLoading(false);
          });
      })
      .catch((error) => {
        changeLoading(false);
      });
  };

  const createAudioCallToken = () => {
    if (process.env.REACT_APP_CALL_SERVICES === "VONAGE") {
      vonageCalling();
    } else {
      resetMessage();
      changeLoading(true);
      dispatch(
        allActions.call.dispatchToStore({
          type: CALL_ACTION_TYPE.audioCallTokenIdle,
        }),
      );
      dispatch(allActions.call.createAudioCallToken());
    }
  };

  const CallEnd = async () => {
    try {
      if (callMeta !== "" && callMeta._boundDestroy()) {
        await callMeta?._boundDestroy();
      }
      setCallData({ status: "" });
      setCallMeta("");
      setTimeout(() => {}, 2000);
    } catch (error) {
      console.log("ERROR???", error);
    }
  };

  const vonageHangUp = () => {
    if (callerUid) {
      axios
        .post(`${BASEURL}/api/vonage/hangup-call`, { call_id: callerUid })
        .then((res) => {})
        .catch((err) => {});
    }
    setCallData({ status: "" });
    //   toggleModalVonage()
  };

  // Reminder SMS

  const sendLoginReminder = async () => {
    if (!lastLead?.user?.phone) {
      setMessage({
        show: true,
        type: "Error",
        text: "Cannot send login reminder: Phone number is missing",
      });
      return false;
    }
    if (!lastLead?.user?.firstname) {
      setMessage({
        show: true,
        type: "Error",
        text: "User firstname is missing, proceeding with generic message",
      });
    }
    const loginUrl = `${window.location.origin}/login`;
    const name = lastLead?.user?.firstname || "there";
    const messageContent = `Hi ${name}, you requested a tax pro, but they can't reach you until you log in! Do it now: [Login Here: ${loginUrl}]`;

    try {
      const response = await axios.post(
        `${BASEURL}/api/auth/send-login-reminder`,
        {
          content: messageContent,
          params: {
            phone: lastLead?.user?.phone,
          },
        },
      );
      if (response.data?.success) {
        setMessage({
          show: true,
          type: "Success",
          text: "Login reminder sendt successfully",
        });
        return true;
      } else {
        setMessage({
          show: true,
          type: "Error",
          text: "Server error",
        });
        return false;
      }
    } catch (error) {
      if (error.response) {
        setMessage({
          show: true,
          type: "Error",
          text: "Server error",
        });
      } else if (error.request) {
        setMessage({
          show: true,
          type: "Error",
          text: "Network error",
        });
      } else {
        console.error("Request configuration error:", error.message);
      }

      return false;
    } finally {
    }
  };

  const handleSendLoginReminderSms = (id) => {
    setSwalProps((prev) => ({
      ...prev,
      [`id-${id}`]: {
        show: true,
        showDenyButton: true,
        title: "Are you sure?",
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        text: "Do you want to send an SMS reminder to the customer to log in?",
        didClose: () =>
          setSwalProps((prev) => ({ ...prev, [`id-${id}`]: { show: false } })),
        onConfirm: () => sendLoginReminder(),
      },
    }));
  };

	
  return (
    <div className="clearfix border-bottom border-light col-12">
      <div className="row video-appointment-height align-items-center">
        {!isAiBotMode && (
          <div className={`${showButtons ? " col-6 " : " col-8"}`}>
            {group && !isAiBotMode && (
              <div className="float-start">
                {chatUsers &&
                  chatUsers?.map((data) => {
                    return (
                      <div
                        className="d-flex flex-row align-items-center px-2  justify-content-start"
                        key={data.id}
                        onClick={() => {
                          if (typeof setShowUserList === "function") {
                            setShowUserList(true);
                          } else {
                            return;
                          }
                        }}
                      >
                        <UserAvatar
                          avatar={user.avatar}
                          alt={`${user.firstname} ${user.lastname}`}
                          className="rounded-circle"
                          width="30"
                        />
                        <p
                          className={`mb-0 px-1 ${!showButtons ? "username-font" : ""}`}
                        >
                          {data?.firstname + " " + data?.lastname}
                        </p>
                        -
                        <p className="mb-0 px-1">
                          {getMyStatus(
                            chatStatus?.data,
                            data?.uuid,
                            "lastSeen",
                          )}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
            {!group && selectedReceiver && !isAiBotMode && (
              <>
                <div className="float-start">
                  <div
                    className="position-relative cursor-pointer"
                    style={{ width: 40, height: 40 }}
                    onClick={() => {
                      if (typeof setShowUserList === "function") {
                        setShowUserList(true);
                      } else {
                        return;
                      }
                    }}
                  >
                    <UserAvatar
                      avatar={selectedReceiver.avatar}
                      alt={`${selectedReceiver.firstname} ${selectedReceiver.lastname}`}
                      className="rounded-circle w-100 h-100 object-fit-cover"
                    />
                    <span
                      className={`position-absolute rounded-circle border border-light bottom-0 end-0${
                        getMyStatus(
                          chatStatus?.data,
                          selectedReceiver?.uuid,
                          "status",
                        ) === "online"
                          ? " bg-success"
                          : " bg-white"
                      }`}
                      style={{
                        width: 10,
                        height: 10,
                      }}
                    ></span>
                  </div>
                </div>
                <div
                  className="d-flex flex-column align-items-start px-2 cursor-pointer"
                  onClick={() => {
                    if (typeof setShowUserList === "function") {
                      setShowUserList(true);
                    } else {
                      return;
                    }
                  }}
                >
                  <p className={`mb-0 ${!showButtons ? "username-font" : ""}`}>
                    {selectedReceiver?.firstname +
                      " " +
                      selectedReceiver?.lastname}
                  </p>
                  <small className="text-capitalize text-responsive w-200 fold-Text-small opacity-75">
                    {selectedReceiver?.role} -
                    <small className="text-muted">
                      <span className="d-none d-md-inline"> Last Seen:</span>
                      <em>
                        {" "}
                        {getMyStatus(
                          chatStatus?.data,
                          selectedReceiver?.uuid,
                          "lastSeen",
                        )}
                      </em>
                    </small>
                  </small>
                  {selectedReceiver?.settings?.timezone && (
                    <small className="text-muted fold-Text-small opacity-75">
                      {timezoneFormatter(selectedReceiver.settings.timezone)}
                      {" · "}
                      {convertTime(selectedReceiver.settings.timezone, "h:mm A")}{" "}
                      local time
                    </small>
                  )}
                  {lastLead?.user?.coupon?.some(c => !c.is_used && (parseFloat(c.amount) - parseFloat(c.used_amount || 0)) > 0) && (
                    <span className="badge bg-success ms-2" style={{ fontSize: '10px' }}>
                      Coupon: ${lastLead.user.coupon.reduce((total, c) => !c.is_used ? total + (parseFloat(c.amount) - parseFloat(c.used_amount || 0)) : total, 0).toFixed(2)}
                    </span>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {isAiBotMode && (
          <div
            className={`container ${isMobile ? "col-12" : ""} ${!isMobile ? "pb-2" : ""}`}
            style={isMobile && modal ? { width: `${windowWidth}px` } : {}}
          >
            <div className="d-flex flex-row align-items-center justify-content-start">
              <Image
                src={require("../../assets/icons/aiDP.png")}
                width={40}
                height={40}
                className="color-primary"
                preview={false}
              />
           <div style={{ marginLeft: 5,lineHeight:1 }}>
  <p className={`m-0 p-0 ${!showButtons ? "username-font" : ""}`}>
    UNK
  </p>
  <small className="text-muted m-0 p-0">
    {LoginData?.roles?.[0]?.display_name} AI
  </small>
</div>

             <div className="d-flex justify-content-start ms-auto gap-3 w-100">
               <Link
                className={`btn btn-sm btn-primary rounded-3 py-2 d-flex flex-row align-items-center justify-content-around ${isAITyping ? 'disabled' : ''}`}
                onClick={() => toggleAiBotMode(false)}
                style={{ marginLeft: 10 }}
              >
                <img
                  src={require("../../assets/icons/cycle.png")}
                  width={13}
                  height={13}
                  className="me-2"
                  alt="cycle"
                />
               <span className="small">Switch Back</span>
              </Link>
              <AiVoiceSupport isMobile={modal} handleSubmit={handleSubmit} />
              </div>

              {/* <Badge className="mx-2 text-xs px-1 py-0.5">
									<small>Beta</small>
								</Badge> */}
            </div>
          </div>
        )}
        {!isAiBotMode && (
          <div className={`${showButtons ? " col-6 " : "col-4"}`}>
            <div className="float-end icon-div d-flex">
              {showButtons ? (
                <>
                  {LoginData?.userpro?.status_id === 6 ? (
                    <button
                      className="btn btn-sm btn-outline-primary px-2 float-md-end float-none d-flex align-tems-center gap-1"
                      disabled={true}
                    >
                      Request documents{" "}
                      <IoIosLock style={{ fontSize: "16px" }} />
                    </button>
                  ) : lastLead && lastLead?.jobs?.length > 0 ? (
                    <Link
                      to="#"
                      className={`btn btn-sm btn-outline-primary mx-1 px-2 ${chatDisable && "disabled"}`}
                      data-bs-toggle={chatDisable ? "" : "modal"}
                      data-bs-target={
                        chatDisable ? "" : "#requestDocumentsModal"
                      }
                      onClick={() => {
                        setSelectedData({
                          job_id: lastLead?.jobs[0]?.id,
                          pro_id: lastLead?.userpro?.id,
                          customer_id: selectedReceiver?.id,
                        });
                      }}
                    >
                      Request documents
                    </Link>
                  ) : null}
                </>
              ) : null}

              {LoginData?.userpro?.status_id === 6 && showButtons ? (
                <button
                  className="btn btn-sm btn-outline-primary px-2 float-md-end float-none d-flex align-tems-center gap-1 mx-2"
                  disabled={true}
                >
                  Job <IoIosLock style={{ fontSize: "16px" }} />
                </button>
              ) : lastLead &&
                lastLead?.jobs?.length < lastLead?.services?.length &&
                showButtons ? (
                <Link
                  to={`/dashboard/jobs/create/${lastLead.uuid}`}
                  className={`btn btn-sm btn-outline-primary mx-1 px-2 ${chatDisable && "disabled"}`}
                  onClick={() => {
                    if (!chatDisable) {
                      dispatch(allActions.dashboard.resetTaxPlanning());
                      dispatch(allActions.dashboard.resetTaxPreparation());
                    }
                  }}
                >
                  Create job
                </Link>
              ) : null}
              <div className="dropdown">
                {(LoginData?.isAdmin || LoginData?.isAccountManager || LoginData?.isSupport || LoginData?.isTaxPro) && !showButtons ?
                <div className="cursor-pointer"
                 onClick={() => {
                    if (typeof setShowUserList === "function") {
                      setShowUserList(true);
                    } else {
                      return;
                    }
                  }}
                >
                    <PiUserListLight color="#4e4d5e"  size={30}/>
                </div>  
              :null}
                {LoginData?.userpro?.status_id === 6 && showButtons ? (
                  <button
                    className="btn btn-sm btn-outline-primary px-2 float-md-end float-none d-flex align-tems-center gap-1 mx-2"
                    disabled={true}
                  >
                    Video Meeting <IoIosLock style={{ fontSize: "16px" }} />
                  </button>
                ) : showButtons ?  (
                  <button
                    className={`btn btn-sm btn-outline-primary mx-1 px-2 dropdown-toggle ${
                      chatDisable && "disabled"
                    }`}
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Video Meeting
                  </button>
                ) : null}
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() =>
                        !chatDisable && navigate("/dashboard/appointments")
                      }
                    >
                      Schedule Appointment
                    </button>
                  </li>
                  {editable && !user.LoginData.isCustomer && (
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          !chatDisable && CreateMeetingLink();
                        }}
                      >
                        Instant Meeting
                      </button>
                    </li>
                  )}
                </ul>
              </div>
              {LoginData?.userpro?.status_id === 6 && showButtons ? (
                <button
                  className="btn btn-sm btn-outline-primary px-2 float-md-end float-none d-flex align-tems-center gap-1"
                  disabled={true}
                >
                  <IoIosLock style={{ fontSize: "16px" }} />
                </button>
              ) : (
                !LoginData.isCustomer &&
                !group &&
                showButtons && (
                  <Link
                    to="#"
                    className="btn btn-sm btn-outline-primary mx-2"
                    onClick={() => {
                      if (selectedReceiver?.phone) {
                        createAudioCallToken();
                      } else {
                        showError("User done't have added phone number");
                        //   phone number missing
                      }
                    }}
                  >
                    <FaPhone className="icons" />
                  </Link>
                )
              )}
              {!lastLead?.user?.isVerify &&
                lastLead?.user?.phone &&
                lastLead?.user?.roles[0]?.name === "customer" &&
                showButtons && (
                  <Link
                    to="#"
                    onClick={() => handleSendLoginReminderSms("1")}
                    className="btn btn-sm btn-outline-primary mx-2"
                  >
                    <BiSolidMessage />
                    <SweetAlert2 {...swalProps[`id-${"1"}`]} />
                  </Link>
                )}
              {editable && showButtons && (
                <div>
                  <Link
                    to={`/faq`}
                    className="btn btn-sm d-none d-md-block "
                    target="_blank"
                  >
                    <BsFillQuestionDiamondFill
                      color="#4b57e7"
                      className="icons"
                    />
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Modal
        title="Request Documents"
        bodyClass="px-5 py-4 text-center"
        trigger="requestDocumentsModal"
        showBtn={false}
        btnClass="requestDocumentsModalClose"
        size="lg"
      >
        {lastLead ? (
          <RequestJobDocumentForm
            data={selectedData}
            customer_id={selectedReceiver.id}
            leadData={lastLead?.user}
            reloadData={loadLastLead}
            closeClass="requestDocumentsModalClose"
            singleDocumentRequest={true}
            modalMessage={modalMessage}
            setmodalMessage={setmodalMessage}
            Heading={[
              { heading: "Name" },
              { heading: "Description" },
              { heading: "Edit" },
              { heading: "Delete" },
            ]}
            buttonText={"Request Document"}
          />
        ) : null}
      </Modal>
      <AudioCallModal
        callData={callData}
        callMeta={callMeta}
        toggleModal={toggleModal}
        selectedReceiver={selectedReceiver}
        CallEnd={CallEnd}
        audioConnection={audioConnection}
      />
      <VonageAudioCallModal
        selectedReceiver={selectedReceiver}
        hangUp={vonageHangUp}
        callData={callData}
      />
    </div>
  );
};

export default UserTopBar;
